module.exports = __webpack_public_path__ + "img/medications-colored.187c0f6d.svg";